<template>
<div>
    <Nav isActive="home"/>
      <div class="pageWD shadowBox mT20">
        <div class="pheader flex flex-sb">
           <img src="../../../assets/images/wodekecheng.png" v-if="type=='course'" style="width:142px; height:58px" />    
           <img src="../../../assets/images/jinqixuexi.png" v-else style="width:142px; height:58px" />              
        </div>
        <div v-if="type=='course'">
          <ul class="plist" v-if="classies.length!=0">
             <li v-for="(item,index) in classies" :key="index" @click="toPlay(item.cmId)">
                 <ClassItem :index="index" :item="item"/>
             </li> 
              <div v-if="lens!='0'">
               <li v-for="(item,index) in 4-lens" >
                  <EmptyItem :index="index" />     
               </li>
             </div>            
          </ul>          
           <div v-else>
            <Empty />
          </div>  
        </div>
        <div v-else>
         <ul class="plist" v-if="classies.length!=0">
             <li v-for="(item,index) in classies" :key="index" @click="toSee(item)">           
                <div  v-if="item.WH_ClassType=='4'" >                
                    <KnowItem :index="index" :item="item"/>         
                </div> 
                <div  v-if="item.WH_ClassType=='1'||item.WH_ClassType =='2' ||item.WH_ClassType =='3'">
                    <ClassItem :index="index" :item="item" type= '2'/>           
                </div>               
             </li> 
            <div v-if="lens!='0'">
               <li v-for="(item,index) in 4-lens" >
                  <EmptyItem :index="index" />     
               </li>
             </div>  
          </ul> 
         <div v-else>
            <Empty />
          </div> 
        </div>
      </div>
     <div style="height:20px"></div>
</div>
</template>
<script>
  import Cookies from "js-cookie";
  import Nav from "../../../components/Nav.vue";
  import ClassItem from "../../../components/ClassItem.vue";
  import Empty from "../../../components/Empty.vue";
  import EmptyItem from "../../../components/EmptyItem.vue";
  import KnowItem from "../../../components/KnowItem.vue";
  import { getClassData ,getStudyHistory } from '@/api/api'
  export default {
    components: {Nav,ClassItem,Empty,EmptyItem,KnowItem},
    data() {
        return {
            classies:[],
            lens:'0',
            type:this.$route.query.type            
        }
    },
    watch:{
       classies(){
          if(this.classies.length){       
            var l = parseInt(this.classies.length/4)
            this.lens =this.classies.length- l*4 
          }
       }
    },
    created() {
        this.type=='course'?this.getClassList():this.getStudyHistoryFun()        
    },
    methods: { 
        toPlay(id){
          this.$router.push({path:'play',query:{courseId:id}});
        },
        getClassList() {
            var that = this;
            let data = {
                memberId: Cookies.get('qslmemberId'),
                COID: Cookies.get('qslCOID'),
                pageIndex: 1,
                pageSize: 100,
                courseType: 0
            };
            getClassData(data)
                .then(res => {
                  console.log( res.body.result)
                  that.classies = res.body.result
                })
                .catch(err => {});
        },
        getStudyHistoryFun(){
          var that = this;
          let data = {
            memberId: Cookies.get('qslmemberId'),
          };
          getStudyHistory(data)
          .then(res => {            
            that.classies = res.body.result  
            console.log(res)   
          })
          .catch(err => {});
        },
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/home/Course/index.vue